// LLM generated - Model Claude 4 Sonnet
import { IconMessageCircle2 } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { EmptyState } from '../../../EmptyState';

function NoChatCommissioner(): JSX.Element {
  const { t } = useTranslation('chat');

  return (
    <EmptyState
      icon={<IconMessageCircle2 size={40} />}
      title={t('emptyStates.noChatsCommissioner.title')}
      description={t('emptyStates.noChatsCommissioner.description')}
      size="md"
      c="gray2.3"
    />
  );
}

export default NoChatCommissioner;
